import { put, takeLatest, call } from 'redux-saga/effects'

import * as orderService from '../../../services/orderService'
import {
  DISPATCH_ORDER,
  DISPATCH_ORDER_SUCCESS,
  DISPATCH_ORDER_ERROR
}
  from '../../actions/order'

function * dispatchOrderSaga (action) {
  try {
    const data = yield call(orderService.DispatchOrder, action.payload)

    yield put({
      type: DISPATCH_ORDER_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: DISPATCH_ORDER_ERROR, error: error.data
    })
  }
}

export function * dispatchOrderSagaWatcher () {
  yield takeLatest(DISPATCH_ORDER, dispatchOrderSaga)
}
